import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ListInfo } from "../../entities/listinfo.model";
import { MediaModel } from "../../entities/media.model";

@Injectable()
export abstract class MediaRepositoryInterface {

    public abstract getMediasByEntity(searchString: string, entityUuid?: string): Observable<[ListInfo, MediaModel[]]>
    public abstract addMedia(body: FormData, entityUuid: string, customTag: string): Observable<MediaModel>;
}
